const repeaterAddItemEvent = new CustomEvent('addevent', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

const repeaterRemoveItemEvent = new CustomEvent('removeevent', {
    detail: {},
    bubbles: true,
    cancelable: true,
    composed: false
});

class Repeater {
    constructor($el) {
        this.el = $el;
        this.list = $el.querySelector('.repeater__list');
        this.listItems = $el.querySelectorAll('.repeater__list .repeater__list-item');
        this.itemContent = $el.querySelector('.repeater__item-content .repeater__list-item');
        this.addBtn = $el.querySelector('.repeater__add-btn');

        if (this.addBtn) {
            this.addBtn.addEventListener('click', () => this.addItem());
        }

        if (this.listItems) {
            this.listItems.forEach($el => {
                this.initDeleteButton($el);
            });
        }
    }

    initDeleteButton($el) {
        const $deleteBtn = $el.querySelector('.repeater__list-item-delete-btn');

        if ($deleteBtn) {
            $deleteBtn.addEventListener('click', () => this.removeItem($el));
        }
    }

    addItem() {
        const $item = this.itemContent.cloneNode(true);
        const $itemRequiredFields = $item.querySelectorAll('.repeater__list-item-field--required');
        const $itemInputs = $item.querySelectorAll('input, textarea, select');

        if ($itemInputs) {
            $itemInputs.forEach($input => {
                const { name } = $input.dataset;

                if (!name) return;

                $input.name = name;
            });
        }

        this.list.appendChild($item);

        this.el.dispatchEvent(repeaterAddItemEvent);

        this.initDeleteButton($item);
    }

    removeItem($el) {
        $el.remove();
        
        this.el.dispatchEvent(repeaterRemoveItemEvent);
    }
}

window.Repeater = Repeater;
